import React from 'react'
import { Trans } from '@lingui/react'
import styled from 'styled-components'

import ActivityForm from './ActivityForm'

import ModalTopBar from '../../layout/ModalTopBar'
import Modal, { ModalMainContainer } from '../../layout/Modal'
import ModalConfirmButtonBar from '../../layout/ModalConfirmButtonBar'

const CreateActivityModal = ({
    formState,
    onClose,
    onSubmit,
    isSubmitting,
}) => (
    <Modal
        data-testid="CreateActivityModal"
        ariaLabel="Create activity"
        islarge="true"
    >
        <ModalTopBar title={<Trans id="Create activity" />} onClose={onClose} />
        <StyledModalMainContainer>
            <ActivityForm formState={formState} />
        </StyledModalMainContainer>
        <ModalConfirmButtonBar
            isSubmitting={isSubmitting}
            onCancel={onClose}
            onSubmit={onSubmit}
        />
    </Modal>
)

const StyledModalMainContainer = styled(ModalMainContainer)`
    min-height: 35rem;
`

export default CreateActivityModal
